import _ from 'lodash'
import moment from 'moment-timezone'
import { PureComponent } from 'react'
import { FileImageOutlined } from '@ant-design/icons'
import { Table } from 'antd'
import styles from '@OpsQuality/styles.css'
import { JOB_REQUEST_INSPECTION_LABELS } from '@OpsQuality/constants'
import { hasMpUploadedAttachments, hqUploadStatus } from '@OpsQuality/logic'

import Link from '~/core/Link'

import { DATE_FORMAT } from './logic'
import { InspectionStatusTag } from './TableColumns'

const ExpandedRow = props => {
    const { record } = props
    const isMpUploaded = hasMpUploadedAttachments(record)
    const inspectionState =
        JOB_REQUEST_INSPECTION_LABELS[record.inspectionStatus]

    return (
        <div>
            <div className={styles.expandedRowHeader}>MP Company</div>
            <div className={styles.expandedRowContent}>
                {record.companyName}
            </div>
            <div className={styles.expandedRowHeader}>Inspection Status</div>
            <div className={styles.expandedRowContent}>
                {inspectionState}
                {isMpUploaded ? <FileImageOutlined /> : ''}
            </div>
            <div className={styles.expandedRowHeader}>HQ Upload</div>
            <div className={styles.expandedRowContent}>
                {record && hqUploadStatus(record.jobRequestAttachments)}
            </div>
        </div>
    )
}

export default class JobRequestListMobileTable extends PureComponent {
    render() {
        const { items, loading, onFilterChange } = this.props

        const staticColumns = [
            {
                title: 'Sort by due date',
                dataIndex: 'vendorDueDate',
                key: 'vendorDueDate',
                render: (text, record) => {
                    let processNameList = []
                    let processTypeList = []

                    if (record) {
                        processNameList = record.linesWithWorkOrderMapping.map(
                            line => line.processName,
                        )
                        processTypeList = record.linesWithWorkOrderMapping.map(
                            line => {
                                return line.processType
                                    ? _.toUpper(line.processType)
                                    : null
                            },
                        )
                    }

                    return {
                        children: (
                            <div>
                                <div>{_.uniq(processTypeList).join(', ')}</div>
                                <div>{_.uniq(processNameList).join(', ')}</div>
                                <div className={styles.expandedRowContent}>
                                    <Link
                                        name="jobRequestLink"
                                        placement={'jobRequestLink-tab'}
                                        to={`/admin/app/operations/quality/${record.id}/`}
                                    >
                                        {record.name}
                                    </Link>
                                </div>
                                <div>SO: {record.salesOrderName}</div>
                                <div>
                                    Job Due:{' '}
                                    {moment(record.vendorDueDate).format(
                                        DATE_FORMAT,
                                    )}
                                </div>
                            </div>
                        ),
                    }
                },
                sorter: (firstElem, secondElem) =>
                    firstElem.vendorDueDate - secondElem.vendorDueDate,
            },
            {
                title: 'Sort by inspection status',
                dataIndex: 'inspectionStatus',
                key: 'inspectionStatus',
                render: value => <InspectionStatusTag reportState={value} />,
                sorter: (firstElem, secondElem) => {
                    if (
                        !(
                            firstElem.inspectionStatus &&
                            secondElem.inspectionStatus
                        )
                    ) {
                        return -1
                    }
                    return firstElem.inspectionStatus <
                        secondElem.inspectionStatus
                        ? -1
                        : 1
                },
            },
        ]

        return (
            <div>
                <Table
                    rowKey="id"
                    columns={staticColumns}
                    loading={loading}
                    dataSource={items || []}
                    pagination={false}
                    expandedRowRender={record => (
                        <ExpandedRow record={record} />
                    )}
                    onChange={(pagination, filters, sorter) => {
                        onFilterChange(pagination, sorter)
                    }}
                />
            </div>
        )
    }
}
